@use '@lib/assets/styles/main' as *;

@keyframes blink {
  from {
    left: -20%;
    width: 20%;
  }
  to {
    left: 120%;
    width: 20%;
  }
}

%blinkBg {
  background: linear-gradient(
    90deg,
    rgba(white, 0) 0%,
    rgba(white, 0.15) 24.48%,
    rgba(white, 0.6) 48.89%,
    rgba(white, 0.15) 75%,
    rgba(white, 0) 100%
  );
}

.loadingPlaceholder {
  background-color: $gray100;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  &::before {
    @extend %blinkBg;
    opacity: 0.6;
    content: '';
    position: absolute;
    width: 60px;
    top: 0;
    bottom: 0;
    left: 0;
    animation: blink 2s linear infinite;
  }
}

.loadingPlaceholderLarge {
  height: 46px;
  margin-bottom: 16px;
}

.loadingPlaceholderMedium {
  height: 36px;
  margin-bottom: 8px;
}

.loadingPlaceholderSmall {
  height: 30px;
  margin-bottom: 8px;
}
